<template>
  <div class="tinymce-container">
    <editor id="explain" v-model="value" :init="init"></editor>
  </div>
</template>

<script>
// import Store from "@/script/store"; //状态管理器VUEX
import { postObject } from "@/script/request/http"; //配置网络请求

import tinymce from "tinymce";
import editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/image";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/charmap";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";

//下面的插件是自带的,不需要引入
// import "tinymce/plugins/contextmenu";
// import "tinymce/plugins/colorpicker";
// import "tinymce/plugins/textcolor";
export default {
  name: "textutil",
  props: {
    tinymceHtml: "",
    // tinymceHeight: {
    //   type: Number,
    //   default: 500,
    // },
  },
  components: {
    editor,
  },
  data() {
    return {
      value: this.tinymceHtml, //父组件通过ref拿到该组件的值
      // superAccount: Store.state.superUser.superAccount,
      init: {
        mode: "exact",
        selector: "#explain",
        placeholder: "请再次输入内容",
        language_url: "/static/tinymce/zh_CN.js",
        language: "zh_CN",
        height: 300,
        skin_url: "/static/tinymce/skins/ui/oxide", //编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件

        plugins:
          "code  lists image imagetools codesample preview table  wordcount insertdatetime autoresize charmap outdent indent", //引入插件
        toolbar1:
          "code codesample fontselect fontsizeselect preview lineheight forecolor backcolor bold italic underline strikethrough | ", //工具栏
        toolbar2:
          "outdent indent alignleft aligncenter alignright alignjustify | image imagetools quicklink h1 h2 h3 blockquote table insertdatetime charmap numlist bullist fullscreen",
        browser_spellcheck: true, // 拼写检查
        branding: false, // 去水印
        elementpath: true, //禁用编辑器底部的状态栏
        statusbar: true, // 隐藏编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        menubar: false, // 隐藏最上方menu

        // convert_fonts_to_spans: false,
        // add_unload_trigger: false,
        // extended_valid_elements: "+body[!class]",
        // verify_html: false,
        // cleanup: true,
        // inline: true,

        schema: "html5",

        // paste_remove_styles: true,
        forced_root_block: false,

        codesample_languages: [
          { text: "HTML/XML", value: "markup" },
          { text: "JavaScript", value: "javascript" },
          { text: "CSS", value: "css" },
          { text: "PHP", value: "php" },
          { text: "Ruby", value: "ruby" },
          { text: "Python", value: "python" },
          { text: "Java", value: "java" },
          { text: "C", value: "c" },
          { text: "C#", value: "csharp" },
          { text: "C++", value: "cpp" },
        ],
        // toolbar: "codesample", // Custom CSS file
        codesample_content_css:
          "http://ourcodeworld.com/material/css/prism.css",

        autoresize_bottom_margin: "50",
        autoresize_max_height: 500,
        autoresize_min_height: 350,
        autoresize_on_init: true,
        autoresize_overflow_padding: 50,

        charmap_append: [
          [0x2615, "morning coffee"],
          [0x2600, "sun"],
          [0x2601, "cloud"],
        ],

        file_picker_types: "image",
        images_upload_credentials: true,
        fontsize_formats: "14px 16px 18px 20px 24px 26px 28px 30px 32px 36px", //字体大小
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue;PingFang SC;sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun;serifsans-serif;Terminal=terminal;monaco;Times New Roman=times new roman;times", //字体

        init_instance_callback: function (editor) {
          tinyMCE.editors["explain"].setContent(
            "<h1>前言</h1>" +
              '<p><span style="color:#999AAA">提示：这里可以添加本文要记录的大概内容：' +
              "<br>例如：随着业务需求的不断发展，某某这门技术也越来越重要，很多人都开启了这个模式进行实践，本文就介绍了某某的基础内容。</span></p>" +
              '<hr><p><span style="color:#999AAA">提示：以下是本篇文章正文内容，下面案例可供参考</span></p>' +
              "<h1>一、kafka是什么？</h1>" +
              '<p><span style="color:#999AAA">示例：Kafka是由Apache软件基金会开发的一个开源流处理平台，由Scala和Java编写。Kafka是一种高吞吐量的分布式发布订阅消息系统，它可以处理消费者在网站中的所有动作流数据。</span></p>' +
              "<h1>二、使用步骤~</h1>" +
              '<ol><li><span style="font-size: 24px;" data-mce-style="font-size: 24px;">~</span></li>' +
              '<li><span style="font-size: 24px;" data-mce-style="font-size: 24px;">~</span></li>' +
              '<li><span style="font-size: 24px;" data-mce-style="font-size: 24px;">~</span></li></ol>' +
              "<h1>总结</h1>" +
              '<p><span style="color:#999AAA">提示：这里对文章进行总结：<br>例如：以上就是今天要讲的内容，本文仅仅简单介绍了kafka的使用。</span></p>'
          );
        },

        /**
         * 下面方法是为tinymce添加自定义插入图片按钮
         * 借助iview的Upload组件,将图片先上传到存储云上，再将图片的存储地址放入编辑器内容
         */
        // 图片上传三个参数，图片数据，成功时的回调函数，失败时的回调函数
        images_upload_handler: function (blobInfo, success, failure) {
          const testmsg = /^image\/(jpeg|png|jpg)$/.test(blobInfo.blob().type);
          const isLt2M = blobInfo.blob().size / 1024 / 1024 <= 2; //图片大小不超过5MB
          if (!testmsg) {
            return failure("只能上传 JPG, JPEG, GIF 和 PNG 格式的图片喔!");
          }
          if (!isLt2M) {
            return failure("上传图片的大小不能超过 2M!");
          }
          let formdata = new FormData();
          formdata.append("file", blobInfo.blob());
          postObject("/vr/upload/file/add", formdata)
            .then((res) => {
              success(res.data.fileUrl);
            })
            .catch((error) => {
              failure(error.data);
            });
        },
      },
    };
  },
  watch: {
    value(newV, oldV) {
      let obj = document.getElementsByTagName("pre");
      for (let i = 0; i < obj.length; i++) {
        obj[i].getAttributeNode("contenteditable").value = "true";
      }
      this.value = newV;
      this.$emit("gettinymceHtml", this.value);
    },
  },
  computed: {},
  created() {},
  mounted() {
    tinymce.init({});
  },
  methods: {},
};
</script>
<style lang="less" scoped>
// .tinymce-container{
//   width: 800px;
//   height: 300px;
//   background-color: aqua;
// }
</style>


// WEBPACK FOOTER //
// src/components/textutil/textutil.vue